import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPen,

} from '@fortawesome/free-solid-svg-icons';

import { 
    withMultipleStyles,
} from '../../../utilities';

import { layoutMuiStyles } from '../../../styles';

class UserEditCompanyRenderer extends React.Component {
    constructor(props) {
        super(props);

        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    invokeParentMethod() {

        //## [DEBUG]
        // console.log('------ invokeParentMethod ------');
        // console.log('------ Data Row ------');
        // console.log(this.props.node)
        // console.log('------ CompanyID ------');
        // console.log(this.props.node.data._id)

        let context = this.props.context;

        if(this.props.node){
            if(this.props.node.data){
                let userId = this.props.node.data._id ? this.props.node.data._id : null;
                context.componentParent.onOpenEditUserCompanyDialog(userId)
            }
        }

    }

    render() {
        const { classes } = this.props;
        return (
            <span>
                <button 
                    onClick={() => this.invokeParentMethod()} 
                    className={
                        classNames(
                            classes.agGridCellButton, 
                        )
                    }
                >
                    <FontAwesomeIcon 
                        icon={faPen}
                        className={
                            classNames(
                                classes.leftIcon, 
                                classes.iconSmall
                            )
                        }
                    />
                    {'แก้ไขบริษัท'}
                </button>
            </span>
        );
    }
};





UserEditCompanyRenderer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
}

//## Mulitple Inject of MUI Theme Styles
var injectedStylesContainers = withMultipleStyles(
    layoutMuiStyles
)(UserEditCompanyRenderer);


export { injectedStylesContainers  as UserEditCompanyRenderer };